import { Device, DeviceInfo } from "@capacitor/device";
import { create } from "zustand";
import { devtools, subscribeWithSelector } from "zustand/middleware";
import { Utils } from "../../utils";

interface IDeviceInfoState {
  deviceInfo: DeviceInfo | null;
  version: {
    buildVersion: string;
    reactVersion: string;
  };
}

export const useDeviceInfo = create<IDeviceInfoState>()(
  subscribeWithSelector(
    devtools(
      (set, _) => {
        Device.getInfo().then((info) => {
          set({ deviceInfo: info });
        });

        return {
          deviceInfo: null,
          version: {
            buildVersion: "",
            reactVersion: "",
          },
        };
      },
      { name: "deviceInfo" },
    ),
  ),
);

/**
 * Starts this module's store subscriptions. `startStoreSubscriptions` (state/store-subscriptions.ts)
 * calls it once, from the app entry, after the whole store graph has loaded.
 */
export function startDeviceInfoSubscriptions() {
  useDeviceInfo.subscribe(
    () => null,
    () => {
      const getVersion = async () => {
        useDeviceInfo.setState({
          version: {
            buildVersion: await Utils.getVersion(),
            reactVersion: Utils.getReactVersion(),
          },
        });
      };
      getVersion();
    },
    {
      fireImmediately: true,
    },
  );
}
